import type {HttpClient} from '@sollapay/http-client';
import type {ApiResponse, UserSettingsDTO} from '@sollapay/types';

/**
 * API client functions for user settings
 */
export const userSettingsApi = {
  /**
   * Fetch the authenticated user's settings
   */
  fetchUserSettings: async (client: HttpClient) =>
    client.get<ApiResponse<UserSettingsDTO>>('/user/settings')
};
